import { SCHOOL_LOGOS_LOADING, SCHOOL_LOGOS_ERROR, SCHOOL_LOGOS_SUCCESS } from "./type";
import { myAxios } from "../../common/myAxios";
import { headers } from "../../common/common";
import { errorMessage, successMessage } from "../../common/message";

const handleLoadingSchoolLogo = (payload) => ({
    type: SCHOOL_LOGOS_LOADING,
    payload,
});

const handleErrorSchoolLogo = () => ({
    type: SCHOOL_LOGOS_ERROR,
});

const handleSuccessSchoolLogo = (payload) => ({
    type: SCHOOL_LOGOS_SUCCESS,
    payload,
});

const getDataSchoolLogos = (data) => async (dispatch) => {
    dispatch(handleLoadingSchoolLogo());
    try {
        return new Promise((resolve, reject) => {
            myAxios
                .post("/user/get-schools", data, { headers: headers() })
                .then((res) => {
                    dispatch(handleSuccessSchoolLogo(res.data.data));
                })
                .catch((error) => {
                    errorMessage(error, reject);
                });
        });
    } catch (error) {
        console.error("Error in User Profile listing", error);
        dispatch(handleErrorSchoolLogo());
    }
};

const setUpSchoolLogo = async (data) => {
    return new Promise((resolve, reject) => {
        myAxios
            .post("/user/setup-school-logos", data, { headers: headers() })
            .then(async (res) => {
                if (res.data.success === true) {
                    resolve(res.data);
                    successMessage(resolve, res);
                    return;
                }
                successMessage(resolve, res);
            })
            .catch((error) => {
                errorMessage(error, reject);
            });
    });
};



const deleteSchoolLogo = async (data) => {
    return new Promise((resolve, reject) => {
        myAxios
            .post("/user/delete-school", data, { headers: headers() })
            .then((res) => {
                successMessage(resolve, res);
            })
            .catch((error) => {
                errorMessage(error, reject);
            });
    });
};

const deleteSchoolLogoImage = async (data) => {
    return new Promise((resolve, reject) => {
        myAxios
            .post("/user/delete-school-image", data, { headers: headers() })
            .then((res) => {
                successMessage(resolve, res);
            })
            .catch((error) => {
                errorMessage(error, reject);
            });
    });
};

export {
    getDataSchoolLogos,
    setUpSchoolLogo,
    deleteSchoolLogo,
    deleteSchoolLogoImage
};
